import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import {
  drawerIsOpenAtom,
  drawerTypeAtom,
} from '@/features/equipment-browser/equipment-drawer-loader/state/drawer.state';

/** Opens and clears the Reset Faulted pane in the equipment drawer. */
export const useOpenResetFaulted = () => {
  const setDrawerIsOpen = useSetAtom(drawerIsOpenAtom);
  const setDrawerType = useSetAtom(drawerTypeAtom);

  const openResetFaultedAction = useCallback(() => {
    setDrawerType('reset-faulted');
    setDrawerIsOpen(true);
  }, [setDrawerIsOpen, setDrawerType]);

  const clearResetFaultedAction = useCallback(() => {
    setDrawerIsOpen(false);
    setDrawerType(undefined);
  }, [setDrawerIsOpen, setDrawerType]);

  return {
    clearResetFaultedAction,
    openResetFaultedAction,
  };
};
